import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { GraphPath, NodeSn } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { selectPathLookupApplied } from '../model/selectors/graphMetadata/selectPathLookupApplied';

export interface ShowGraphLayoutDialogCommand {
  nodeSns?: NodeSn[];
  path: GraphPath;
}

export const showGraphLayoutDialog: GraphCommandFactory<
  ShowGraphLayoutDialogCommand
> = (cmdContext) => (command) => {
  if (selectPathLookupApplied(cmdContext.getState())) {
    stumble('Graph layout change is not allowed for Path-lookup');
    return;
  }
  cmdContext.updateState((draft) => {
    draft.graphLayoutDialog = {
      nodeSns: command.nodeSns,
      path: command.path,
    };
  });
};
